import React from 'react';
import {getChapters, postLearningDetail} from './service';
const getStudyParamsFromUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const searchEntries = searchParams.entries();
    const obj = {};
    // eslint-disable-next-line no-undef
    for (const [key, value] of searchEntries) {
        // eslint-disable-next-line no-undef
        obj[key] = /^[\d]+/.test(value) ? ~~value : value;
    }
    return obj;
};
window.getInComingStudyInfo = () => {
    const originStudyInfo = getStudyParamsFromUrl();
    ['courseId', 'classId', 'levelIndex', 'unitIndex', 'userId'].forEach(key => {
        if (originStudyInfo[key] === undefined) {
            originStudyInfo[key] = 0;
        }
    });
    ['subject', 'subjectId'].forEach(key => {
        if (originStudyInfo[key] === undefined) {
            originStudyInfo[key] = 1;
        }
    });
    ['unitName'].forEach(key => {
        if (originStudyInfo[key] === undefined) {
            originStudyInfo[key] = '';
        }
    });
    originStudyInfo.locale = 'zh-cn';
    if (originStudyInfo.appEnv === undefined) {
        const strMatch = location.host.match((/testing[\d]*/));
        if (strMatch && strMatch.length) {
            originStudyInfo.appEnv = strMatch[0];
        }
    }
    if (originStudyInfo.appEnv === undefined) {
        originStudyInfo.appEnv = 'prod';
    }
    return originStudyInfo;
};
const ServiceHoc = function (WrappedComponent) {
    class Service extends React.Component {
        constructor (props) {
            super(props);
            this.state = {
                chapter: null,
                error:''
            };
            this.handleChapterPassed = this.handleChapterPassed.bind(this);
            const {unitId, subjectId, chapterId} = window.getInComingStudyInfo();
            getChapters({unitId, subjectId}).then(res => res.json())
                .then(json => {
                    if (json.errCode === 0 && json.data) {
                        const chapter = json.data.chapters.find(chapterItem => chapterItem.id === chapterId);
                        this.setState({
                            chapter
                        });
                        this.createOwnBar(chapter.info.name || '无chapterName');
                        this.enterTime = Date.now();
                        if (chapter.itemType !== 'PROJECT') {
                            this.setState({
                                error: '你所要备课的并不是project，请检查crm入口'
                            });
                        }
                    }
                })
                .catch(e => {
                    alert(`获取chapter数据失败${e.message}`);
                });
            window.nextStudy = this.handleChapterPassed;
        }
        componentDidMount () {
        }
        createOwnBar(name){
            const bar = document.createElement('div');
            bar.style.position = 'fixed';
            bar.style.top = '0';
            bar.style.left = '0';
            bar.style.width = '100%';
            bar.style.height = '60px';
            bar.style.textAlign = 'center';
            bar.style.lineHeight = '60px';
            bar.style.color = '#fff';
            bar.style.backgroundColor = '#414f76';
            bar.innerHTML = name;
            document.body.appendChild(bar);
        }
        handleChapterPassed (){
            const {itemId, itemType} = this.state.chapter;
            const {
                staffId,
                teacherId,
                unitId
            } = window.getInComingStudyInfo();
            const learningTime = Date.now() - this.enterTime;
            const args = {
                itemId,
                itemType,
                staffId,
                teacherId,
                unitId,
                learningTime
            };
            return postLearningDetail(args);
        }
        handleGoNext (){
        }
        render () {
            if (this.state.error) return (<div style={{padding: '20px',color:'#fff'}}>{this.state.error}</div>);
            if (this.state.chapter === null) return '备课内容加载中...';
            return (<WrappedComponent
                // onChapterPassed={this.handleChapterPassed}
                // onGoNextTheme={this.handleGoNext}
                projectUrl={this.state.chapter.info.projectUrl}
            />);
        }
    }
    return Service;
};
export {
    ServiceHoc as default
};
